export default __webpack_public_path__ + "static/media/pic6.58a24457.png";